<template>
<Teleport to="#modal-portal-target">
<div v-if="$store.getters['common/modalName'] === 'resourcecontrols'">
    <div class="modal-header">
        <h3 class="modal-title">
            {{ $_locale('resource controls') }}
        </h3>
    </div>
    <div class="modal-body reservation-modal userteetime-modal">
        <div class="panel-body" style="padding: 0;">
            <wn-table-pages 
                :items="resources"
                :perPage="50"
                :pagingOptions="[25, 50, -1]">
                <template #head>
                    <th>{{ $_locale('resource') }}</th>
                    <th></th>
                </template>
                <template v-slot="{ item: row }">
                    <tr :key="row.reservationTimeId">
                        <td>{{ row.resourceName }}</td>
                        <td>
                            <button class="btn btn-xs btn-danger" 
                                v-if="row.isDisabled"
                                @click="enableResource(row)">
                                {{ $_locale('disabled') }}
                            </button>
                            <button class="btn btn-xs btn-success" 
                                v-else
                                @click="disableResource(row)">
                                {{ $_locale('in use') }}
                            </button>
                        </td>
                    </tr>
                </template>
            </wn-table-pages>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-default pull-left" 
            @click="$store.commit('common/setModal', null)">
            {{ $_locale('close') }}
        </button>
    </div>
</div>
</Teleport>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: () => ({
    }),
    computed: {
        ...mapGetters({
            product: 'ecom/product',
            date: 'reservations/date',
            adminMode: 'common/adminMode',
            settings: 'reservations/settings',
            resourceRules: 'reservations/resourceRules',
        }),
        resources() {
            const date = this.date;
            const { resources } = this.settings
            const resourceRules = this.resourceRules

            return resources.map(row => {
                const [ rule ] = resourceRules.filter(
                    rule => rule.ruleName === 'aikaSulku'
                        && rule.resourceId == row.resourceId
                )

                row.isDisabled = typeof rule !== 'undefined';
                row.disablingRule = rule;

                return row;
            })
        },  
    },
    methods: {
        async enableResource(row) {
            const { productId } = this.product
            const { resourceId, disablingRule } = row
            const { ruleId } = disablingRule
            // row has a disablingRule, use ruleId to delete the rule
            // update resourceRules in store
            const { data } = await this.$_http({
                method: 'POST',
                url: `${ window.wisenetwork.REST_URL }/reservations/addremoveresourcefreeze/`,
                data: {
                    method: 'remove',
                    productId,
                    resourceId,
                    ruleId
                },
                withCredentials: true,
            })

            if (!data.success) {
                return this.handleError(data)
            }

            this.$store.commit('reservations/removeResourceRule', ruleId)
        },
        async disableResource(row) {
            const { productId } = this.product
            const { resourceId } = row
            const startDate = moment(this.date).format('YYYY-MM-DD')
            // create a new resource rule with recurrenceDays all days and starting selected date
            // update resourceRules in store
            const { data } = await this.$_http({
                method: 'POST',
                url: `${ window.wisenetwork.REST_URL }/reservations/addremoveresourcefreeze/`,
                data: {
                    method: 'add',
                    productId,
                    resourceId,
                    startDate
                },
                withCredentials: true,
            })

            if (!data.success) {
                return this.handleError(data)
            }

            this.$store.commit('reservations/setResourceRules', data.resourceRules)
        },
        handleError(data) {
            const title = data.message || this.$_locale('error while saving');

            this.$_swal({
                title,
                icon: 'error',
                confirmButtonText: 'OK',
            })
        },
    },
    mounted() {
        
    }
}
</script>